export const GET_STORES = "STORE/GET_STORES";
export const GET_STORES_SUCCESS = "STORE/GET_STORES_SUCCESS";
export const GET_STORES_FAILURE = "STORE/GET_STORES_FAILURE";

